/**
 * Página /contracts (CONTRATOS/FATURAMENTO, estilo Tiflux): abas teal-ink
 * Contratos | Faturamentos pendentes | Histórico, com a aba na URL (?tab=).
 */
import { z } from 'zod';
import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ContractsTab } from './contracts-tab';
import { PendingTab } from './pending-tab';
import { HistoryTab } from './history-tab';

export const billingSearchSchema = z.object({
  tab: z.enum(['contracts', 'pending', 'history']).default('contracts').catch('contracts'),
});
export type BillingSearch = z.infer<typeof billingSearchSchema>;

const routeApi = getRouteApi('/_authenticated/contracts');

const TAB_TRIGGER_CLASSES =
  'h-10 flex-none rounded-none px-1 text-sm font-medium data-[state=active]:text-primary after:h-0.5 after:bg-primary group-data-[orientation=horizontal]/tabs:after:bottom-0';

export function BillingPage() {
  const { tab } = routeApi.useSearch();
  const navigate = useNavigate();

  const setTab = (next: string) =>
    void navigate({ to: '/contracts', search: { tab: next as BillingSearch['tab'] } });

  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab} className="gap-4">
        <div className="rounded-lg border bg-card shadow-xs">
          <div className="px-4 pt-3">
            <h1 className="text-xl leading-7 font-semibold">Contratos</h1>
          </div>
          <TabsList
            variant="line"
            className="mt-1 w-full justify-start gap-6 rounded-none p-0 px-4 group-data-[orientation=horizontal]/tabs:h-11"
          >
            <TabsTrigger value="contracts" className={TAB_TRIGGER_CLASSES}>
              Contratos
            </TabsTrigger>
            <TabsTrigger value="pending" className={TAB_TRIGGER_CLASSES}>
              Faturamentos pendentes
            </TabsTrigger>
            <TabsTrigger value="history" className={TAB_TRIGGER_CLASSES}>
              Histórico
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="contracts">
          <ContractsTab />
        </TabsContent>
        <TabsContent value="pending">
          <PendingTab />
        </TabsContent>
        <TabsContent value="history">
          <HistoryTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
